<div class="dropdown">
  <select [formControl]="control" autocomplete="off" [ngClass]="{'input-error': control.invalid }"   [attr.data-field]="field?.fieldUuid"
  [attr.data-typeId]="field?.config?.typeId" [attr.aria-label]="field?.config?.label" [attr.tabIndex]="0">
    <option value=""></option>
    <option *ngFor="let optionValue of field.config.choices"
            [ngValue]="optionValue"> {{ optionValue[keys(optionValue)[0]] }}
    </option>
  </select>
</div>
